<template>
  <div class="search-bd" :class="[{fixed: fixed},{white: white}]">
    <div v-if="tleft.icon || tleft.text" class="search-left" @click="onEmit('left')">
      <slot name="left">
        <i v-if="tleft.icon" class="iconfont" :class="'icon-'+tleft.icon"></i>
        <span v-text="tleft.text"></span>
      </slot>
    </div>
    <div class="search-box">
      <i class="iconfont icon-search"></i>
      <input v-if='!disabled' type="text" ref="input" name="keyword" id="keyword" v-model="currentValue" @focus="onEmit('focus')" @blur="onEmit('blur')" @input="change()" :placeholder="placeholder">
      <a v-if='!disabled' class="iconfont icon-delete" @click="clear()" v-show="currentValue" href="javascript:void(0)"></a>
      <p v-if='disabled'>{{placeholder}}</p>
    </div>
    <div v-if="tright.icon || tright.text" class="search-right" @click="onEmit('right')">
      <slot name="left">
        <i v-if="tright.icon" class="iconfont" :class="'icon-'+tright.icon"></i>
        <span v-text="tright.text"></span>
      </slot>
    </div>
  </div>
</template>
<script>
/**
   * @param placeholder [String] 输入框默认文字
   * @param tleft [Object] 左边内容包含icon(图标)，text(文字)
   * @param tright [Object] 右边内容包含icon(图标)，text(文字)
   * @param value [String] 输入框v-model绑定值
   * @param fixed [String] 是否固定在顶部
   * @param white [String] 是否为全部显示为(白色+透明背景)类型
   * @param disabled [String] 输入框是否可编辑
   * @param change [Function] 输入框变更触发事件
   * @param clear [Function] 清除输入框触发事件
   * @param on-left [Function] 点击左边触发事件
   * @param on-right [Function] 点击右边触发事件
   * @describe
   *
   * @example
   *
   <t-search disabled fixed white :tleft="{icon: 'location', text: '深圳'}" placeholder="搜索商品名称" @change=""></t-search>
   */
export default {
  name: 'tSearch',
  props: {
    placeholder: String,
    tleft: {
      type: Object,
      default: function () {
        return {};
      },
    },
    tright: {
      type: Object,
      default: function () {
        return {};
      },
    },
    value: {
      type: String,
      default: '',
    },
    fixed: {
      type: Boolean,
      default: false,
    },
    white: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentValue: this.value,
      isFocus: false,
      isFixed: false,
    };
  },
  watch: {
    value(val) {
      this.currentValue = val; // 新增value的watch，监听变更并同步到currentValue上,适用于外部操作的变更
    },
  },
  mounted: function () {},
  methods: {
    change() {
      this.$emit('input', this.currentValue);
      this.$emit('change', this.currentValue);
    },
    setFocus() {
      this.$refs.input.focus();
    },
    setBlur() {
      this.$refs.input.blur();
    },
    clear() {
      this.currentValue = '';
      this.$emit('input', this.currentValue);
      this.$emit('clear');
      this.setFocus();
    },
    onEmit(name) {
      this.$emit(`on-${name}`);
    },
  },
};

</script>
<style lang="scss">
@import "../style/mixin";

.search-bd {
   ::-webkit-input-placeholder {
    color: #B0B1AC;
    font-weight: normal;
  }
  display: flex;
  position: relative;
  padding: 7px 10px;
  background: #FFFFFF;
  box-shadow: 0 1px 10px #dedede;
  &.fixed {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 6;
  }
  &.white {
    background: none;
    box-shadow: none;
    .search-box {
      background: #ffffff
    }
    .search-right i,
    .search-right span,
    .search-left i,
    .search-left span {
      color: #ffffff;
    }
  }
  .search-box {
    flex: 1;
    -webkit-flex: 1;
    padding-left: 30px;
    padding-right: 30px;
    height: 100%;
    width: 100%;
    background-color: #EFEFF4;
    border-radius: 3px;
    @include border-1px(#E6E6EA, 6px);
    i {
      position: absolute;
      left: 10px;
      top: 0;
      line-height: 30px;
      color: #B2B2B2;
      font-size: 15px;
      z-index: 1;
    }
    input {
      position: relative;
      z-index: 3;
      padding: 4px 0;
      width: 100%;
      height: 22px;
      border: 0;
      font-size: 14px;
      line-height: 22px;
      box-sizing: content-box;
      outline: none;
      background: transparent;
    }
    a {
      position: absolute;
      top: 0;
      right: 0;
      padding: 0 10px;
      line-height: 28px;
      color: #B2B2B2;
      font-size: 14px;
      z-index: 2;
    }
    p {
      height: 22px;
      border: 0;
      font-size: 14px;
      line-height: 22px;
      color: #B0B1AC;
      padding: 4px 0;
      box-sizing: content-box;
    }
  }
  .search-right {
    margin-left: 10px;
    line-height: 30px;
    height: 30px;
    color: #FF9900;
    white-space: nowrap;
    font-size: 14px;
    i {
      font-size: 20px;
      color: #f80052;
    }
    span {
      float: right;
      margin-left: 4px;
      color: #343434;
    }
  }
  .search-left {
    margin-right: 10px;
    line-height: 30px;
    height: 30px;
    color: #FF9900;
    white-space: nowrap;
    font-size: 14px;
    i {
      font-size: 20px;
      color: #000;
    }
    span {
      float: right;
      margin-left: 4px;
      color: #343434;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/search.vue